const categoryList = [
    '全部',
    '中枢神经系统',
    '头颈部',
    '呼吸系统',
    '循环系统',
    '乳腺',
    '消化系统和腹膜腔',
    '泌尿生殖系统和腹膜后间隙',
    '骨骼肌肉系统',
    '儿科疾病',
];

export { categoryList };
